var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-05"},[_c('div',{staticClass:"f-light break-word"},[_vm._t("default"),(_vm.required)?_c('span',{staticClass:"c-red ml-02"},[_vm._v("*")]):_c('span',{staticClass:"ml-01"},[_vm._v("(Optional)")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }